import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { ProductAttributes } from "../../recommendation.types";

export const requestGetProductAttributes = async (
  id: string
): Promise<ProductAttributes> => {
  return await instance.get(
    `${ApiRoutesRecommendation.Enrichment}/${encodeURIComponent(id)}`
  );
};
